import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Tampilkan data cache tanpa refetch instan saat pindah menu — tidak
        // ada flash/skeleton berulang. Refetch hanya saat data benar-benar
        // basi (5 menit) atau saat user kembali online.
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 30,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        retry: 1,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Preload saat user hover / touch link — ringan tapi tetap instan saat
    // menu di-tap. "render" terlalu berat karena fetch semua link sekaligus
    // → menyebabkan flash & lag saat shell mount.
    defaultPreload: "intent",
    defaultPreloadDelay: 50,
    // Pakai staleTime yang sama dengan query supaya loader tidak refetch
    // ulang saat berpindah route → tampilan lama tetap utuh tanpa flash.
    defaultPreloadStaleTime: 1000 * 60 * 5,
    defaultPreloadGcTime: 1000 * 60 * 30,
  });

  return router;
};
